{
  "info": "Informace",
  "negative": "Chyba",
  "notice": "Varování",
  "positive": "Úspěch"
}
